"use client";
import { createContext, useContext, useEffect, useRef } from "react";
import { z } from "zod";
import type { WebMcpRuntime } from "./runtime";
import type { WebMcpBinding } from "./types";

export const WebMcpContext = createContext<WebMcpRuntime | null>(null);
export function useWebMcpTool<S extends z.ZodType>(binding: WebMcpBinding<S>) {
  const runtime = useContext(WebMcpContext);
  const latest = useRef(binding);
  useEffect(() => { latest.current = binding; });
  const schemaKey = JSON.stringify(z.toJSONSchema(binding.schema));
  useEffect(() => {
    if (!runtime || binding.enabled === false) return;
    return runtime.bind({ ...binding,
      execute: (input, context) => latest.current.execute(input as z.output<S>, context),
      preview: (input) => latest.current.preview?.(input as z.output<S>) ?? JSON.stringify(input, null, 2),
    });
    // Callbacks are read at invocation; schema changes invalidate the registration.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runtime, binding.action, binding.instance, binding.enabled, schemaKey]);
}
